export async function fetchAllPages<TPage, TItem>(options: {
  fetchPage: (page: number) => Promise<TPage>;
  getItems: (page: TPage) => TItem[];
  pageSize: number;
  maxPages?: number;
}): Promise<{ firstPage: TPage; items: TItem[] }> {
  const { fetchPage, getItems, pageSize, maxPages = 25 } = options;
  let page = 1;
  let allItems: TItem[] = [];
  let firstPage: TPage | undefined;

  while (page <= maxPages) {
    const result = await fetchPage(page);
    if (page === 1) firstPage = result;
    const items = getItems(result);
    allItems = allItems.concat(items);
    if (items.length < pageSize) break;
    page++;
  }

  return { firstPage: firstPage as TPage, items: allItems };
}
